<template>
  <div class="article-slider">
    <div v-if="slides && slides.length > 2" class="">
      <swiper ref="articleSlider" :options="optionsPaginationTop" class="">
        <swiper-slide v-for="(article, index) in slides" :key="index">
          <Article
            :title="article.title"
            :desc="article.summary"
            :date="article.datePublished"
            :size="null"
            :link="article.url"
            :author="article.author"
            :has-access="hasAccess"
          />
        </swiper-slide>
      </swiper>
      <DirectionButton
        :props-handle-click="prev"
        class="report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev"
        :direction="'prev'"
        :icon="'arrow-left--white'"
      />
      <DirectionButton
        :props-handle-click="next"
        class="report-slider__pagination--next report-slider__pagination-top--next swiper-button-next"
        :direction="'next'"
        :icon="'arrow-right--white'"
      />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "ArticleSlider",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Article: () => import("@/components/elements/Article"),
    DirectionButton: () => import("@/components/elements/DirectionButton"),
    Swiper,
    SwiperSlide,
  },
  props: {
    slides: {
      type: Array,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionsPaginationTop: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 45,
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
        },
        navigation: {
          nextEl: ".report-slider__pagination-top--next",
          prevEl: ".report-slider__pagination-top--prev",
        },
      },
    };
  },
  methods: {
    goToPrev() {
      this.$refs.productsSlider.prev();
    },
    goToNext() {
      this.$refs.productsSlider.next();
    },
    next() {
      const slider = "articleSlider";
      this.$refs[slider].$swiper.slideNext();
    },
    prev() {
      const slider = "articleSlider";
      this.$refs[slider].$swiper.slidePrev();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.article-slider {
  overflow: hidden;
  margin: 1rem 0 0;

  .report-slider__pagination--prev,
  .report-slider__pagination--next {
    position: absolute;
    top: 0;
  }

  .report-slider__pagination--next {
    right: 3rem;
    background: $accentBlue;

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }

  .report-slider__pagination--prev {
    left: auto;
    right: 6.7rem;
    background: $accentBlue;

    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-top: 3.5rem solid $accentBlue;
      border-left: 1rem solid transparent;
      left: -1rem;
      top: 0;
      bottom: 0;
    }

    @include below($lg) {
      top: auto;
      bottom: 0;

      &::before {
        display: none;
      }
    }
  }
}
</style>
